module.exports = __webpack_public_path__ + "img/money.b84f6576.png";